export enum VideoColorEnum {
	RedPurple = 'redPurple'
}
